import * as React from "react";
import type { SVGProps } from "react";

const VehicleTruckTrailer = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M10.668 12.2817H5.56055"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.6697 8.66778H12.3354C12.1513 8.66778 12.002 8.51848 12.002 8.33431V6H14.3361"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.3729 11.628C12.659 11.9141 12.7446 12.3444 12.5898 12.7182C12.4349 13.092 12.0702 13.3358 11.6655 13.3358C11.2609 13.3358 10.8961 13.0921 10.7412 12.7183C10.5864 12.3445 10.6719 11.9142 10.9581 11.628L10.9581 11.628C11.3488 11.2373 11.9822 11.2373 12.3729 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M1.33105 2.66453H6.66661"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M6.66602 2.66504C7.03436 2.66504 7.33296 2.96364 7.33296 3.33198"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M7.33347 3.33203V7.3337"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M3.03887 11.628C3.325 11.9141 3.41061 12.3444 3.25578 12.7183C3.10096 13.0921 2.73618 13.3359 2.33155 13.3359C1.92692 13.3359 1.56212 13.0922 1.40725 12.7184C1.25239 12.3445 1.33796 11.9142 1.62407 11.6281L1.62427 11.6279C1.81186 11.4403 2.06629 11.3349 2.33159 11.335C2.59688 11.335 2.8513 11.4404 3.03886 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M5.15606 11.628C5.44219 11.9141 5.5278 12.3444 5.37297 12.7183C5.21814 13.0921 4.85337 13.3359 4.44874 13.3359C4.0441 13.3359 3.6793 13.0922 3.52444 12.7184C3.36958 12.3445 3.45515 11.9142 3.74125 11.6281L3.74145 11.6279C3.92905 11.4403 4.18348 11.3349 4.44877 11.335C4.71407 11.335 4.96848 11.4404 5.15604 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.6654 12.3358H14.0026C14.3709 12.3358 14.6695 12.0372 14.6695 11.6689V6.98179C14.6695 6.77464 14.6213 6.57035 14.5286 6.38509L13.7039 4.73622C13.4779 4.28441 13.0161 3.99902 12.5109 3.99902H9.33398"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M1.33105 9.33448H9.33439V2.66504"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
));
VehicleTruckTrailer.displayName = "VehicleTruckTrailer";

export default VehicleTruckTrailer;
